import { render, staticRenderFns } from "./TedsLauncherGlobalSearch.vue?vue&type=template&id=7dd006b6&"
import script from "./TedsLauncherGlobalSearch.vue?vue&type=script&lang=ts&"
export * from "./TedsLauncherGlobalSearch.vue?vue&type=script&lang=ts&"
import style0 from "./TedsLauncherGlobalSearch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports